import React from 'react';
import {ProductConsumer} from '../context';
import styled from 'styled-components'

const Footer = () => {
    return (
        <ProductConsumer>
            {value=>{
                return (
                    <FooterWrapper>
                        <div className="container py3">
                            <div className="row m-0">
                                <div className="col-md-6">
                                    <p className="text-capitalize">
                                        copyright &copy; tech store {new Date().getFullYear()} all right reserved{" "}
                                    </p>
                                </div>
                                <div className="col-md-6 d-flex justify-content-around">
                                    {value.socialIcons.map(item=>{
                                        return (
                                            <a href={item.url} key={item.id}>{item.icon}</a>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </FooterWrapper>
                )
            }}
        </ProductConsumer>
    );
};

const FooterWrapper =styled.footer`
background:var(--darkGrey);
color:var(--mainWhite);
.icon{
    font-size:1.5rem;
    color:var(--mainWhite);
    transition:var(--mainTransation);
}
.icon:hover{
    color:var(--primaryColor);
    cursor:pointer
}
`;
export default Footer;